import React, { memo } from 'react'
import Skeleton from 'react-loading-skeleton'
import { colors } from 'src/theme/colors'

function FaqSkeletonComponent() {
  return (
    <>
      <br />
      <Skeleton height={40} width="100%" baseColor={colors.palette.neutral500} />
      <br />
      <Skeleton height={30} width="100%" baseColor={colors.palette.neutral500} />
      <br />
      <Skeleton height={100} width="100%" baseColor={colors.palette.neutral500} />
      <br />
      <Skeleton height={30} width="100%" baseColor={colors.palette.neutral500} />
      <br />
      <Skeleton height={100} width="100%" baseColor={colors.palette.neutral500} />
      <br />
      <br />
    </>
  )
}

export const FaqSkeleton = memo(FaqSkeletonComponent)
